import script from "./CallDominantSpeaker.vue?vue&type=script&setup=true&lang=ts"
export * from "./CallDominantSpeaker.vue?vue&type=script&setup=true&lang=ts"

import "./CallDominantSpeaker.vue?vue&type=style&index=0&id=90fcbaa8&lang=scss"

const __exports__ = script;

export default __exports__